import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { PageLoader } from '../components/Authentication/page-loader';

const Authorize = () => {
  const { isLoading, isAuthenticated, loginWithRedirect } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    const processAuth = async () => {
      if (isAuthenticated) {
        navigate('/home'); // Redirect to home if already authenticated
      } else if (!isLoading) {
        await loginWithRedirect(); // Handle Auth0 redirection
      }
    };

    processAuth();
  }, [isAuthenticated, isLoading, navigate, loginWithRedirect]);

  return <PageLoader />;
};

export default Authorize;
